import React from 'react';
import { Typography, Paper, Box, Alert, CircularProgress, Chip, Stack, useTheme, alpha } from '@mui/material';
import PageBackground from '../components/PageBackground';
import ConstructionIcon from '@mui/icons-material/Construction';
import UpdateIcon from '@mui/icons-material/Update';
import { ANIMATION_PRESETS } from '../theme/animations';

const ExceptionWriting: React.FC = () => {
  const theme = useTheme();
  
  return (
    <PageBackground>
      <Typography 
        variant="h4" 
        gutterBottom 
        sx={{ 
          color: theme.palette.text.primary, 
          ...ANIMATION_PRESETS.fadeIn 
        }}
      >
        Exception Writing
      </Typography>
      
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          backgroundColor: 'rgba(255, 255, 255, 0.95)', 
          backdropFilter: 'blur(10px)', 
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          borderRadius: 2,
          transition: 'transform 0.3s ease-in-out',
          '&:hover': {
            transform: 'translateY(-5px)',
          },
          ...ANIMATION_PRESETS.slideInUp
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <ConstructionIcon 
            color="warning" 
            sx={{ 
              fontSize: 40, 
              mr: 2,
              animation: 'rotate 3s infinite linear',
              '@keyframes rotate': {
                '0%': {
                  transform: 'rotate(0deg)',
                },
                '100%': {
                  transform: 'rotate(360deg)',
                },
              },
            }} 
          />
          <Typography 
            variant="h5" 
            sx={{ 
              fontWeight: 'bold',
              color: theme.palette.warning.dark 
            }}
          >
            Work in Progress
          </Typography>
        </Box>
        
        <Alert 
          severity="info" 
          variant="filled" 
          sx={{ 
            mb: 4,
            '& .MuiAlert-icon': {
              fontSize: '1.5rem'
            }
          }}
        >
          The Exception Writing module is currently under development. We're working hard to deliver this feature soon.
        </Alert>
        
        <Stack 
          direction="row" 
          spacing={2} 
          alignItems="center" 
          sx={{ 
            mb: 3,
            p: 2, 
            backgroundColor: alpha(theme.palette.primary.light, 0.1),
            borderRadius: 2
          }}
        >
          <CircularProgress size={24} thickness={5} />
          <Typography>
            Estimated completion: Coming soon
          </Typography>
        </Stack>
        
        <Box sx={{ mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            Planned Features:
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 2 }}>
            <Chip label="Exception Templates" color="primary" />
            <Chip label="Policy Guidelines" color="primary" />
            <Chip label="Collaborative Editing" color="primary" />
            <Chip label="Exception History" color="primary" />
            <Chip label="AI-Assisted Writing" color="secondary" />
          </Stack>
        </Box>
        
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            mt: 4, 
            pt: 2,
            borderTop: `1px solid ${theme.palette.divider}`
          }}
        >
          <UpdateIcon color="action" sx={{ mr: 1 }} />
          <Typography variant="body2" color="text.secondary">
            Last updated: {new Date().toLocaleDateString()}
          </Typography>
        </Box>
      </Paper>
    </PageBackground>
  );
};

export default ExceptionWriting; 